'use strict';

var _dataservice = require('@sunl-fe/dataservice');

var _util = require('./common/util.js');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file 官网 - banner拉新
 * 
 * @auth gushouchuang 
 * @date 2020-4-20 
 * 
 * @update dengjinglei 需求修改，去除验证码验证，定位于屏幕右下方
 * @date 2020-5-25
*/

var laxinToast = $('#laxinToast');
var laxinModal = $('#laxinModal');
var laxinCnt = $('#laxinCnt');
var laxin_phone = $('#laxin_phone');
var laxinSubmit = $('#laxinSubmit');
var laxin_from = $('#laxin_from');
var laxin_erweima = $('#laxin_erweima');

var stHanlder = null;

// 提示话术 toast 3s
var showToast = function showToast(val) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    laxinToast.find('p span').html(val);
    laxinToast.show();
    // 成功类提示 添加隐藏x图片的class
    if (type === 1) {
        laxinToast.removeClass('toastSuccess');
    } else {
        laxinToast.addClass('toastSuccess');
    }

    clearTimeout(stHanlder);

    stHanlder = setTimeout(function () {
        laxinToast.hide();
    }, 3000);
};

// 校验手机号
var verifyPhone = function verifyPhone(val) {
    var reg = /^\d{11}$/g;
    var rst = true;

    if (!reg.test(val)) {
        showToast('请输入正确手机号');
        rst = false;
    }

    return rst;
};

// 校验验证码
// const verifyCode = val => {
//     const reg = /^\d{4}$/g
//     let rst = true

//     if (!reg.test(val)) {
//         showToast('请输入正确验证码')
//         rst = false
//     }

//     return rst
// }

// 超长截断
var subText = function subText() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    var rst = val;

    if (val.length > length) {
        rst = val.substring(0, length);
    }

    return rst;
};

// 展示拉新弹窗
$("#laxinBtn").click(function () {
    // 判断laxinModal是否隐藏，隐藏则显示，不隐藏则抖动提示
    if (laxinModal.is(':hidden')) {
        laxinModal.show();
    } else {
        _util2["default"].shake(laxinCnt, 'right');
    }
    // 悬浮按钮
    _util2["default"].slog('click_free_button', {});
    // 弹窗曝光
    _util2["default"].slog('login_popup_show', {});

    return;
});

// 关闭弹窗
$("#laxinClose").click(function () {
    laxinModal.hide();
    return;
});

// 领取submit
laxinSubmit.click(function () {
    var phoneNum = laxin_phone.val();

    if (verifyPhone(phoneNum)) {
        // 领取
        (0, _dataservice.getJSON)('/advertisement/getCourse', {
            mobile: phoneNum.trim()
        }).then(function (data) {
            // 未付费
            if (data.isVip === 0 && data.imageUrl) {
                // data.imageUrl 二维码图片
                $('#laxin_erweima_img').attr('src', data.imageUrl);
                laxin_from.hide();
                laxin_erweima.show();

                // 微信二维码曝光
                _util2["default"].slog('wechat_popup_show', {});
            } else {
                showToast('报名失败，该活动仅针对未付费学员');
            }
        })["catch"](function (e) {
            showToast(e);
            // showToast('报名失败，该活动仅针对未付费学员')
        });
    }

    return;
});

// 最长输入11个长度
laxin_phone.on('input', function (e) {
    var val = e.target.value;

    laxin_phone.val(subText(val, 11));
    return;
});


//////////////////
// WEBPACK FOOTER
// ./src/js/laxin.js
// module id = 82
// module chunks = 4